// Rolling upgrades must not break the whole dashboard on an older backend.
// Retry only this read-only summary and only the new field's schema rejection;
// never retry mutations, auth failures, partial results, or general errors.
function legacyWebhookSummaryRequest(request, response) {
  if (!/^\s*query\s+getUserSummary\b/.test(request?.query || '') ||
      !response?.errors?.length || response.data != null ||
      !response.errors.every(error => /^Cannot query field "webhookSecretConfigured" on type "MeetingRoomParams"/.test(error.message || ''))) {
    return null;
  }
  // Object.assign, not spread: Babel turns spread into an ES helper import,
  // and webpack rejects module.exports in a module that imports.
  return Object.assign({}, request, { query: request.query.replace(/\bwebhookSecretConfigured\b/g, '') });
}

module.exports = { legacyWebhookSummaryRequest };
